import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { ResidentDiscount } from '../ResidentDiscount/ResidentDiscountDesktop';
import { ConnectedFlightsManagerLegDesktop } from '../FlightsManager/FlightsManagerLegDesktop';
import { DateDesktop } from '../FlightsManager/DesktopFields';
import { FieldType, SearchSegment } from '../../models';
import { SearchButtonStyled } from '../SearchButton';
import { getRooms, getSegments, showKidsErrors } from '../../redux/currentSearch/selectors';
import { CMS } from '../../utils';
import { RoomSelector } from '../RoomSelector/RoomSelectorDesktop';
import { ConnectedSeparateStayCalendars, ConnectedSeparateStayCheckbox } from '../SeparateStay';
import { SegmentContext } from '../FlightsManager/Segment/SegmentManager/Context';

import { SegmentManagerDpEl } from './SegmentManagerDp.style';
import { CarsSearchExtension } from '../CarsSearchExtension';
import { ClickTrackDPDates, ClickTrackDPRooms } from '../HotelManager/SearchFormFieldsClickableWrapper';
import { DP_SEARCH_FORM, withTrackComponentDisplayed } from '../../utils/HtmlEvents';


export class SegmentManagerDp extends PureComponent {
    state = {
        fieldFocused: null,
    };

    componentDidUpdate(prevProps) {
        const { segments } = this.props;
        const { fieldFocused } = this.state;
        const prevSegments = prevProps.segments;
        if (prevSegments !== segments ) {
            const changedSegment = this.getChangedSegment(prevSegments);
            const changedPrevSegment = this.getChangedPrevSegment(prevSegments);
            if ((!fieldFocused || !this.cleanCityFocused(fieldFocused.field, changedSegment)) &&
                !this.swapWasClicked(changedPrevSegment, changedSegment)) {
                this.focusNextField(segments);
            }
        }
    }

    getChangedPrevSegment(prevSegments) {
        const { segments } = this.props;
        return prevSegments.find((prevSegment, i) => segments[i] !== prevSegment);
    }

    getChangedSegment(prevSegments) {
        const { segments } = this.props;
        return segments.find((segment, i) => segment !== prevSegments[i]);
    }

    onChangeFocus = (field, focus, index) => {
        const leg = index ? index : 0;
        if (focus) {
            this.setState({
                fieldFocused: {
                    leg: leg,
                    field: field,
                },
            });
        } else {
            this.setState({ fieldFocused: false });
        }
    };

    onChangeFocusReturnLeg = (field, focus) => {
        this.onChangeFocus(field, focus, 1);
    };

    cleanCityFocused = (field, segment) => {
        return field === FieldType.DEPARTURE && !segment.origin || (field === FieldType.ARRIVAL && !segment.destination);
    };

    swapWasClicked = (prevSegment, segment) => {
        return segment && ((!!segment.origin === !!prevSegment.destination) ||
            (prevSegment.destination && prevSegment.destination.geoNodeId === 0)) &&
            segment.destination === prevSegment.origin &&
            segment.date === prevSegment.date;
    };

    focusNextField = (segments) => {
        let fieldFocused = null;
        if (this.showRoomComponent(false)) {
            fieldFocused = { field: FieldType.ROOM };
        } else if (!segments[0].origin) {
            fieldFocused = { leg: 0, field: FieldType.DEPARTURE };
        } else if (!segments[0].destination) {
            fieldFocused = { leg: 0, field: FieldType.ARRIVAL };
        } else if (!segments[0].date) {
            fieldFocused = { leg: 0, field: FieldType.DATE };
        } else if (segments.length < 2 || !segments[1].date) {
            fieldFocused = { leg: 1, field: FieldType.DATE };
        }
        this.setState({
            fieldFocused,
        });
    };

    showRoomComponent(defaultOrder ) {
        const { segments, showKidsErrors } = this.props;
        return showKidsErrors &&
            (defaultOrder ||
                (
                    !!segments[0].origin &&
                    !!segments[0].destination &&
                    !!segments[0].date &&
                    !(segments.length < 2 || !segments[1].date)
                )
            );
    }

    render() {
        const { fieldFocused } = this.state;
        const { segments } = this.props;
        const fieldOpen = fieldFocused ? fieldFocused.field : null;
        const legFieldOpen = fieldFocused ? fieldFocused.leg : null;
        const firstIndex = 0;
        const secondIndex = 1;
        const [firstSegment, secondSegment] = segments;

        return (
            <SegmentManagerDpEl>
                <SegmentContext.Provider value={{ segment: firstSegment }}>
                    <div className="SegmentManagerDP-Leg odf-space-inner-bottom-s">
                        <div className="odf-row odf-row-nogutter">
                            <ConnectedFlightsManagerLegDesktop
                                fieldFocused={fieldOpen}
                                onChangeFocus={this.onChangeFocus}
                            />
                        </div>
                    </div>
                    <div
                        className="SegmentManagerDP-Departure"
                        data-testid="departure-date-picker"
                    >
                        <ClickTrackDPDates>
                            <DateDesktop
                                isDatesRangeShown
                                open={
                                    fieldOpen === FieldType.DATE &&
                                    legFieldOpen === firstIndex
                                }
                                onChangeFocus={this.onChangeFocus}
                                placeholderKey="calendar.departureDate"
                            />
                        </ClickTrackDPDates>
                    </div>
                </SegmentContext.Provider>
                <SegmentContext.Provider value={{ segment: secondSegment }}>
                    <div
                        className="SegmentManagerDP-Return"
                        data-testid="return-date-picker"
                    >
                        <ClickTrackDPDates>
                            <DateDesktop
                                isDatesRangeShown
                                open={
                                    fieldOpen === FieldType.DATE &&
                                    legFieldOpen === secondIndex
                                }
                                onChangeFocus={this.onChangeFocusReturnLeg}
                                placeholderKey="calendar.returnDate"
                            />
                        </ClickTrackDPDates>
                    </div>
                </SegmentContext.Provider>
                <div className="SegmentManager-Rooms-Pax">
                    <ClickTrackDPRooms>
                        <RoomSelector
                            fieldFocused={fieldOpen}
                            setFieldFocused={(state, focus)=>this.onChangeFocus(state, focus)}
                        />
                    </ClickTrackDPRooms>
                </div>
                <div className="SegmentManagerDP-SSCheckbox">
                    <CarsSearchExtension tab="dp" />
                    <ConnectedSeparateStayCheckbox />
                    <ResidentDiscount />
                </div>
                <ConnectedSeparateStayCalendars />

                <div className="SegmentManagerDP-CTA odf-space-inner-left-s">
                    <SearchButtonStyled dynPack>
                        <CMS id="flightsManager.search.reduced" />
                    </SearchButtonStyled>
                </div>
            </SegmentManagerDpEl>
        );
    }
}

SegmentManagerDp.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    showKidsErrors: PropTypes.bool,
};

SegmentManagerDp.defaultProps = {
    segments: [],
    rooms: [],
    showKidsErrors: false,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    rooms: getRooms,
    showKidsErrors: showKidsErrors,
});

const ConnectedSegmentManagerDp = connect(
    mapStateToPropsSelector,
    {},
)(withTrackComponentDisplayed(SegmentManagerDp, DP_SEARCH_FORM));
export { ConnectedSegmentManagerDp };
